export function coarseStripHTML(s) {
    let result = '';
    let inTag = false;
    for (let i = 0, l = s.length; i < l; i++) {
        const char = s[i];
        if (char === '<') {
            inTag = true;
        }
        else if (char === '>') {
            inTag = false;
        }
        else if (!inTag) {
            result += char;
        }
    }
    return result;
}
